import type { LayoutDocument, LayoutElement } from './types'

/** The design's own booking buttons. */
export function bookingButtons(doc: LayoutDocument): LayoutElement[] {
  return doc.elements.filter((el) => el.kind === 'button' && el.action?.kind === 'booking')
}

/** Booking buttons a kiosk leaves undrawn (their place kept) while no booking is due today. */
export function bookingHidden(doc: LayoutDocument, due: boolean): string[] {
  return due ? [] : bookingButtons(doc).map((el) => el.id)
}
